import { CHAT_RESUME_ACTION, CHAT_START_NEW_ACTION } from './messageTemplates'

export const acTestTemplate = {
  type: "AdaptiveCard",
  "$schema": "http://adaptivecards.io/schemas/adaptive-card.json",
  "version": "1.5",
  "body": [
    {
      "type": "ColumnSet",
      "targetWidth": "atLeast:standard",
      "horizontalAlignment": "center",
      "columns": [
        {
          "$data": "${greetings}",
          "type": "Column",
          "width": "stretch",
          "items": [
            {
              "type": "Container",
              "style": "emphasis",
              "height": "stretch",
              "horizontalAlignment": "center",
              "items": [
                {
                  "type": "Image",
                  "url": "${icon}",
                  "size": "medium",
                  "spacing": "small",
                  "horizontalAlignment": "center"
                },
                {
                  "type": "TextBlock",
                  "text": "${title}",
                  "weight": "bolder",
                  "size": "medium",
                  "wrap": true,
                  "horizontalAlignment": "center",
                  "spacing": "medium"
                },
                {
                  "type": "TextBlock",
                  "text": "${description}",
                  "wrap": true,
                  "isSubtle": true,
                  "horizontalAlignment": "center",
                  "spacing": "small"
                }
              ],
              "selectAction": {
                "type": "Action.Submit",
                "data": {
                  "action": "${action}"
                }
              }
            }
          ]
        }
      ]
    },
    {
      "$data": "${greetings}",
      "type": "Container",
      "targetWidth": "atMost:narrow",
      "style": "emphasis",
      "spacing": "medium",
      "items": [
        {
          "type": "ColumnSet",
          "columns": [
            {
              "type": "Column",
              "width": "auto",
              "items": [
                {
                  "type": "Image",
                  "url": "${icon}",
                  "size": "small"
                }
              ]
            },
            {
              "type": "Column",
              "width": "stretch",
              "verticalContentAlignment": "center",
              "items": [
                {
                  "type": "TextBlock",
                  "text": "${title}",
                  "weight": "bolder",
                  "wrap": true
                },
                {
                  "type": "TextBlock",
                  "text": "${description}",
                  "wrap": true,
                  "isSubtle": true,
                  "spacing": "none"
                }
              ]
            }
          ]
        }
      ],
      "selectAction": {
        "type": "Action.Submit",
        "data": {
          "action": "${action}"
        }
      }
    }
  ]
}

export const acTestData = {
  "greetings": [
    {
      "icon": "https://adaptivecards.io/content/cats/1.png",
      "title": "Start a New Chat",
      "description": "Begin a fresh conversation with the assistant.",
      "action": CHAT_START_NEW_ACTION
    },
    {
      "icon": "https://adaptivecards.io/content/cats/2.png",
      "title": "Resume Previous Chat",
      "description": "Continue where you left off earlier.",
      "action": CHAT_RESUME_ACTION
    },
    {
      "icon": "https://adaptivecards.io/content/cats/3.png",
      "title": "Explore Templates",
      "description": "Choose from predefined conversation templates.",
      "action": "browse_templates"
    }
  ]
}

export const acActivityUpdateTemplate = {
  "type": "AdaptiveCard",
  "body": [
    {
      "type": "TextBlock",
      "size": "medium",
      "weight": "bolder",
      "text": "${title}",
      "style": "heading",
      "wrap": true
    },
    {
      "type": "ColumnSet",
      "columns": [
        {
          "type": "Column",
          "items": [
            {
              "type": "Image",
              "style": "person",
              "url": "${creator.profileImage}",
              "altText": "${creator.name}",
              "size": "small"
            }
          ],
          "width": "auto"
        },
        {
          "type": "Column",
          "items": [
            {
              "type": "TextBlock",
              "weight": "bolder",
              "text": "${creator.name}",
              "wrap": true
            },
            {
              "type": "TextBlock",
              "spacing": "none",
              "text": "Created {{DATE(${string(createdUtc)}, SHORT)}}",
              "isSubtle": true,
              "wrap": true
            }
          ],
          "width": "stretch"
        }
      ]
    },
    {
      "type": "TextBlock",
      "text": "${description}",
      "wrap": true
    },
    {
      "type": "FactSet",
      "facts": [
        {
          "$data": "${properties}",
          "title": "${key}:",
          "value": "${value}"
        }
      ]
    }
  ],
  "actions": [
    {
      "type": "Action.ShowCard",
      "title": "Set due date",
      "card": {
        "type": "AdaptiveCard",
        "body": [
          {
            "type": "Input.Date",
            "label": "Enter the due date",
            "id": "dueDate"
          },
          {
            "type": "Input.Text",
            "id": "comment",
            "isMultiline": true,
            "label": "Add a comment"
          }
        ],
        "actions": [
          {
            "type": "Action.Submit",
            "title": "OK"
          }
        ],
        "$schema": "http://adaptivecards.io/schemas/adaptive-card.json"
      }
    },
    {
      "type": "Action.OpenUrl",
      "title": "View",
      "url": "${viewUrl}",
      "role": "button"
    }
  ],
  "$schema": "http://adaptivecards.io/schemas/adaptive-card.json",
  "version": "1.5"
}

export const acActivityUpdateData = {
  "title": "Publish Adaptive Card Schema",
  "description": "Now that we have defined the main rules and features of the format, we need to produce a schema and publish it to GitHub. The schema will be the starting point of our reference documentation.",
  "creator": {
    "name": "Matt Hidinger",
    "profileImage": "https://pbs.twimg.com/profile_images/3647943215/d7f12830b3c17a5a9e4afcc370e3a37e_400x400.jpeg"
  },
  "createdUtc": "2017-02-14T06:08:39Z",
  "viewUrl": "https://adaptivecards.io",
  "properties": [
    { "key": "Board", "value": "Adaptive Cards" },
    { "key": "List", "value": "Backlog" },
    { "key": "Assigned to", "value": "Matt Hidinger" },
    { "key": "Due date", "value": "Not set" }
  ]
}

export const acBoundInputsTemplate = {
  "type": "AdaptiveCard",
  "$schema": "http://adaptivecards.io/schemas/adaptive-card.json",
  "version": "1.5",
  "body": [
    {
      "type": "TextBlock",
      "text": "Bound Input Example",
      "weight": "bolder",
      "size": "medium",
      "wrap": true
    },
    {
      "type": "Input.Text",
      "id": "title",
      "label": "Title",
      "value": "${title}"
    },
    {
      "type": "Input.Text",
      "id": "description",
      "label": "Description",
      "isMultiline": true,
      "value": "${description}"
    },
    {
      "type": "Input.Number",
      "id": "maxTokens",
      "label": "Max tokens",
      "value": "${maxTokens}"
    },
    {
      "type": "Input.Date",
      "id": "reviewDate",
      "label": "Review date",
      "value": "${reviewDate}"
    },
    {
      "type": "Input.Time",
      "id": "reviewTime",
      "label": "Review time",
      "value": "${reviewTime}"
    },
    {
      "type": "Input.Toggle",
      "id": "enabled",
      "title": "Enabled",
      "valueOn": "true",
      "valueOff": "false",
      "value": "${enabled}"
    },
    {
      "type": "Input.ChoiceSet",
      "id": "provider",
      "label": "Provider",
      "style": "compact",
      "value": "${provider}",
      "choices": [
        { "title": "OpenAI", "value": "openai" },
        { "title": "Azure OpenAI", "value": "azure_openai" },
        { "title": "Bedrock", "value": "bedrock" }
      ]
    }
  ],
  "actions": [
    {
      "type": "Action.Submit",
      "title": "Submit"
    }
  ]
}

export const acBoundInputsData = {
  "title": "Admissions Assistant",
  "description": "Supports undergraduate admissions questions.",
  "maxTokens": 1024,
  "reviewDate": "2026-03-10",
  "reviewTime": "09:30",
  "enabled": "true",
  "provider": "azure_openai"
}

export const acChartDoughnutTemplate = {
  "type": "AdaptiveCard",
  "$schema": "http://adaptivecards.io/schemas/adaptive-card.json",
  "version": "1.5",
  "body": [
    {
      "type": "Widget.Tabs",
      "headerLabel": "${month}",
      "defaultTabIndex": "${defaultTabIndex}",
      "tabs": [
        {
          "$data": "${days}",
          "label": "${label}",
          "sublabel": "${sublabel}",
          "items": [
            {
              "type": "Chart.Progress",
              "label": "Calories",
              "value": "${calories}",
              "max": "${calorieGoal}",
              "unit": "kcal",
              "color": "#f97316",
              "spacing": "small"
            },
            {
              "type": "Chart.Doughnut",
              "title": "${formatNumber(calories, 0)}kcal",
              "subtitle": "${formatNumber(calorieGoal, 0)}kcal",
              "spacing": "default",
              "items": [
                { "label": "CHO", "value": "${carbs}",   "max": "${carbGoal}",    "unit": "g", "color": "#4ade80" },
                { "label": "PRO", "value": "${protein}", "max": "${proteinGoal}", "unit": "g", "color": "#60a5fa" },
                { "label": "FAT", "value": "${fat}",     "max": "${fatGoal}",     "unit": "g", "color": "#f97316" }
              ]
            }
          ]
        }
      ]
    }
  ]
}

const GOALS = { calorieGoal: 2000, carbGoal: 250, proteinGoal: 120, fatGoal: 70 }

export const acChartDoughnutWeeklyData = [
  { label: 'Sun', sublabel: '19', calories: 1850, carbs: 218, protein: 92,  fat: 63,  ...GOALS },
  { label: 'Mon', sublabel: '20', calories: 2100, carbs: 258, protein: 108, fat: 74,  ...GOALS },
  { label: 'Tue', sublabel: '21', calories: 1740, carbs: 210, protein: 88,  fat: 59,  ...GOALS },
  { label: 'Wed', sublabel: '22', calories: 87,   carbs: 5,   protein: 10,  fat: 3,   ...GOALS },
  { label: 'Thu', sublabel: '23', calories: 0,    carbs: 0,   protein: 0,   fat: 0,   ...GOALS },
  { label: 'Fri', sublabel: '24', calories: 0,    carbs: 0,   protein: 0,   fat: 0,   ...GOALS },
  { label: 'Sat', sublabel: '25', calories: 0,    carbs: 0,   protein: 0,   fat: 0,   ...GOALS },
]

export const acChartDoughnutData = {
  month: 'Feb',
  defaultTabIndex: 3,
  days: acChartDoughnutWeeklyData,
}


export const acExpenseReportTemplate = {
  "type": "AdaptiveCard",
  "body": [
    {
      "type": "Container",
      "style": "emphasis",
      "items": [
        {
          "type": "ColumnSet",
          "columns": [
            {
              "type": "Column",
              "items": [
                {
                  "type": "TextBlock",
                  "size": "large",
                  "weight": "bolder",
                  "text": "**EXPENSE APPROVAL**",
                  "style": "heading",
                  "wrap": true
                }
              ],
              "width": "stretch"
            },
            {
              "type": "Column",
              "items": [
                {
                  "type": "Image",
                  "url": "${status_url}",
                  "altText": "${status}",
                  "height": "30px"
                }
              ],
              "width": "auto"
            }
          ]
        }
      ],
      "bleed": true
    },
    {
      "type": "Container",
      "items": [
        {
          "type": "ColumnSet",
          "columns": [
            {
              "type": "Column",
              "items": [
                {
                  "type": "TextBlock",
                  "size": "extraLarge",
                  "text": "${purpose}",
                  "wrap": true,
                  "style": "heading"
                }
              ],
              "width": "stretch"
            },
            {
              "type": "Column",
              "items": [
                {
                  "type": "ActionSet",
                  "actions": [
                    {
                      "type": "Action.OpenUrl",
                      "title": "EXPORT AS PDF",
                      "url": "https://adaptivecards.io"
                    }
                  ]
                }
              ],
              "width": "auto"
            }
          ]
        },
        {
          "type": "TextBlock",
          "spacing": "small",
          "size": "small",
          "weight": "bolder",
          "text": "[${code}](https://adaptivecards.io)",
          "wrap": true
        },
        {
          "type": "FactSet",
          "spacing": "large",
          "facts": [
            {
              "title": "Submitted By",
              "value": "**${created_by_name}**  ${creater_email}"
            },
            {
              "title": "Duration",
              "value": "${formatTicks(min(select(expenses, x, int(x.created_by))), 'yyyy-MM-dd')} - ${formatTicks(max(select(expenses, x, int(x.created_by))), 'yyyy-MM-dd')}"
            },
            {
              "title": "Submitted On",
              "value": "${formatDateTime(submitted_date, 'yyyy-MM-dd')}"
            },
            {
              "title": "Reimbursable Amount",
              "value": "$${formatNumber(sum(select(expenses, x, if(x.is_reimbursable, x.total, 0))), 2)}"
            },
            {
              "title": "Awaiting approval from",
              "value": "**${approver}**  ${approver_email}"
            },
            {
              "title": "Submitted to",
              "value": "**${other_submitter}**   ${other_submitter_email}"
            }
          ]
        }
      ]
    },
    {
      "type": "Container",
      "spacing": "large",
      "style": "emphasis",
      "items": [
        {
          "type": "TextBlock",
          "weight": "bolder",
          "text": "EXPENSE DETAILS",
          "wrap": true
        }
      ],
      "bleed": true
    },
    {
      "type": "ActionSet",
      "$data": "${expenses}",
      "actions": [
        {
          "type": "Action.ShowCard",
          "title": "${formatDateTime(created_time, 'MM-dd')}: ${description} - $${formatNumber(total, 2)}",
          "card": {
            "type": "AdaptiveCard",
            "body": [
              {
                "type": "Container",
                "items": [
                  {
                    "type": "Container",
                    "items": [
                      {
                        "$data": "${custom_fields}",
                        "type": "TextBlock",
                        "text": "* ${value}",
                        "isSubtle": true,
                        "wrap": true
                      },
                      {
                        "type": "Container",
                        "items": [
                          {
                            "type": "Input.Text",
                            "id": "comment${$index}",
                            "label": "Add your comment here"
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "type": "Container",
                    "items": [
                      {
                        "type": "ColumnSet",
                        "columns": [
                          {
                            "type": "Column",
                            "items": [
                              {
                                "type": "ActionSet",
                                "actions": [
                                  {
                                    "type": "Action.Submit",
                                    "title": "Send",
                                    "data": {
                                      "id": "_qkQW8dJlUeLVi7ZMEzYVw",
                                      "action": "comment",
                                      "lineItem": 1
                                    }
                                  }
                                ]
                              }
                            ],
                            "width": "auto"
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        }
      ]
    },
    {
      "type": "ColumnSet",
      "spacing": "large",
      "separator": true,
      "columns": [
        {
          "type": "Column",
          "items": [
            {
              "type": "TextBlock",
              "horizontalAlignment": "right",
              "text": "Total Expense Amount \t",
              "wrap": true
            },
            {
              "type": "TextBlock",
              "horizontalAlignment": "right",
              "text": "Non-reimbursable Amount",
              "wrap": true
            },
            {
              "type": "TextBlock",
              "horizontalAlignment": "right",
              "text": "Advance Amount",
              "wrap": true
            }
          ],
          "width": "stretch"
        },
        {
          "type": "Column",
          "items": [
            {
              "type": "TextBlock",
              "text": "$${formatNumber(sum(select(expenses, x, x.total)), 2)}",
              "wrap": true
            },
            {
              "type": "TextBlock",
              "text": "(-) $${formatNumber(sum(select(expenses, x, if(x.is_reimbursable, 0, x.total))), 2)} \t",
              "wrap": true
            },
            {
              "type": "TextBlock",
              "text": "(-) 0.00 \t",
              "wrap": true
            }
          ],
          "width": "auto"
        },
        {
          "type": "Column",
          "width": "auto"
        }
      ]
    },
    {
      "type": "Container",
      "style": "emphasis",
      "items": [
        {
          "type": "ColumnSet",
          "columns": [
            {
              "type": "Column",
              "items": [
                {
                  "type": "TextBlock",
                  "horizontalAlignment": "right",
                  "text": "Amount to be Reimbursed",
                  "wrap": true
                }
              ],
              "width": "stretch"
            },
            {
              "type": "Column",
              "items": [
                {
                  "type": "TextBlock",
                  "weight": "bolder",
                  "text": "$${formatNumber(sum(select(expenses, x, if(x.is_reimbursable, x.total, 0))), 2)}",
                  "wrap": true
                }
              ],
              "width": "auto"
            },
            {
              "type": "Column",
              "width": "auto"
            }
          ]
        }
      ],
      "bleed": true
    },
    {
      "type": "ActionSet",
      "actions": [
        {
          "type": "Action.ShowCard",
          "title": "Show history",
          "card": {
            "type": "AdaptiveCard",
            "body": [
              {
                "type": "Container",
                "items": [
                  {
                    "type": "TextBlock",
                    "text": "* Expense submitted by **${created_by_name}** on {{DATE(${formatDateTime(created_date, 'yyyy-MM-ddTHH:mm:ssZ')}, SHORT)}}",
                    "isSubtle": true,
                    "wrap": true
                  },
                  {
                    "type": "TextBlock",
                    "text": "* Expense ${expenses[0].status} by **${expenses[0].approver}** on {{DATE(${formatDateTime(approval_date, 'yyyy-MM-ddTHH:mm:ssZ')}, SHORT)}}",
                    "isSubtle": true,
                    "wrap": true
                  }
                ]
              }
            ]
          }
        }
      ]
    },
    {
      "type": "Container",
      "items": [
        {
          "type": "ActionSet",
          "actions": [
            {
              "type": "Action.Submit",
              "title": "Approve",
              "style": "positive",
              "data": {
                "id": "_qkQW8dJlUeLVi7ZMEzYVw",
                "action": "approve"
              }
            },
            {
              "type": "Action.ShowCard",
              "title": "Reject",
              "style": "destructive",
              "card": {
                "type": "AdaptiveCard",
                "body": [
                  {
                    "type": "Input.Text",
                    "id": "RejectCommentID",
                    "label": "Please specify an appropriate reason for rejection",
                    "isMultiline": true,
                    "isRequired": true,
                    "errorMessage": "A reason for rejection is necessary"
                  }
                ],
                "actions": [
                  {
                    "type": "Action.Submit",
                    "title": "Send",
                    "data": {
                      "id": "_qkQW8dJlUeLVi7ZMEzYVw",
                      "action": "reject"
                    }
                  }
                ],
                "$schema": "http://adaptivecards.io/schemas/adaptive-card.json"
              }
            }
          ]
        }
      ]
    }
  ],
  "$schema": "http://adaptivecards.io/schemas/adaptive-card.json",
  "version": "1.5",
  "fallbackText": "This card requires Adaptive Cards v1.5 support to be rendered properly."
}

export const acExpenseReportData = {
  "code": "ER-13052",
  "message": "success",
  "created_by_name": "Matt Hidinger",
  "created_date": "2019-07-15T18:33:12+0800",
  "submitted_date": "2019-04-14T18:33:12+0800",
  "creater_email": "matt@contoso.com",
  "status": "Pending",
  "status_url": "https://adaptivecards.io/content/pending.png",
  "approver": "Thomas",
  "purpose": "Trip to UAE",
  "approval_date": "2019-07-15T22:33:12+0800",
  "approver_email": "thomas@contoso.com",
  "other_submitter": "David",
  "other_submitter_email": "david@contoso.com",
  "expenses": [
    {
      "expense_id": "16367000000083065",
      "approver": "Thomas",
      "date": "2017-02-21",
      "description": "Air Travel Expense",
      "created_by": "636965431200000000",
      "created_by_name": "PATRICIA",
      "employee_number": "E001",
      "currency_id": "16367000000000097",
      "currency_code": "USD",
      "paid_through_account_id": "16367000000036003",
      "paid_through_account_name": "Employee Reimbursements",
      "bcy_total": 13900.79,
      "bcy_subtotal": 13900.79,
      "total": 300,
      "total_without_tax": 300,
      "is_billable": true,
      "is_reimbursable": true,
      "reference_number": "DD145",
      "due_days": "Due in 15 days",
      "merchant_id": "16367000000074027",
      "merchant_name": "ABS Solutions",
      "status": "approved",
      "created_time": "2019-06-19T18:33:12+0800",
      "last_modified_time": "2017-02-21T18:42:46+0530",
      "receipt_name": "receipt1.jpg",
      "report_id": "16367000000083075",
      "mileage_type": "non_mileage",
      "report_name": "Purchase",
      "is_receipt_only": false,
      "distance": 0,
      "per_diem_rate": 0,
      "per_diem_days": 0,
      "per_diem_id": "",
      "per_diem_name": "",
      "expense_type": "non_mileage",
      "location": "Washington",
      "receipt_type": "jpg",
      "policy_violated": false,
      "comments_count": 0,
      "report_status": "submitted",
      "price_precision": 2,
      "mileage_rate": 0,
      "mileage_unit": "km",
      "receipt_status": "processed",
      "is_uncategorized": false,
      "is_expired": false,
      "gl_code": "LG001",
      "exchange_rate": 66.943366,
      "start_reading": "",
      "end_reading": "",
      "payment_mode": "Check",
      "customer_id": "27927000000075081",
      "customer_name": "ACME Corp.",
      "custom_fields": [
        {
          "customfield_id": "16367000000277001",
          "label": "Other Name",
          "value": "Leg 1 on Tue, Jun 19th, 2019 at 6:00 AM."
        },
        {
          "customfield_id": "16367000000277001",
          "label": "Other Name",
          "value": "Leg 2 on Tue, Jun 19th, 2019 at 7:15 PM."
        }
      ],
      "project_id": "27927000001243001",
      "project_name": "Coffee Research",
      "transaction_description": "",
      "tax_id": "16367000000086001",
      "tax_name": "Sales Tax",
      "tax_percentage": 2,
      "amount": 207.65,
      "is_inclusive_tax": false,
      "vehicle_type": "Bike",
      "vehicle_id": "17456000000078029",
      "fuel_type": "lpg",
      "engine_capacity_range": "between_1401cc_and_1600cc",
      "is_personal": false,
      "policy_id": "16367000000092011",
      "policy_name": "LIC",
      "documents": [
        {
          "file_name": "receipt1.jpg",
          "file_size_formatted": "71.8 KB",
          "attachment_order": 1,
          "document_id": "16367000000083071"
        }
      ],
      "reimbursement_reference": "",
      "reimbursement_date": "",
      "reimbursement_paid_through_account_id": "",
      "reimbursement_paid_through_account_name": "",
      "reimbursement_currency_id": "",
      "reimbursement_currency_code": ""
    },
    {
      "expense_id": "16367000000083065",
      "date": "2019-06-19",
      "description": "Auto Mobile Expense",
      "created_by": "636965431200000000",
      "created_by_name": "PATRICIA",
      "employee_number": "E001",
      "currency_id": "16367000000000097",
      "currency_code": "USD",
      "paid_through_account_id": "16367000000036003",
      "paid_through_account_name": "Employee Reimbursements",
      "bcy_total": 13900.79,
      "bcy_subtotal": 13900.79,
      "total": 100,
      "total_without_tax": 100,
      "is_billable": true,
      "is_reimbursable": true,
      "reference_number": "DD145",
      "due_days": "Due in 15 days",
      "merchant_id": "16367000000074027",
      "merchant_name": "ABS Solutions",
      "status": "submitted",
      "created_time": "2019-06-19T18:33:12+0800",
      "last_modified_time": "2017-02-21T18:42:46+0530",
      "receipt_name": "receipt1.jpg",
      "report_id": "16367000000083075",
      "mileage_type": "non_mileage",
      "report_name": "Purchase",
      "is_receipt_only": false,
      "distance": 0,
      "per_diem_rate": 0,
      "per_diem_days": 0,
      "per_diem_id": "",
      "per_diem_name": "",
      "expense_type": "non_mileage",
      "location": "Washington",
      "receipt_type": "jpg",
      "policy_violated": false,
      "comments_count": 0,
      "report_status": "submitted",
      "price_precision": 2,
      "mileage_rate": 0,
      "mileage_unit": "km",
      "receipt_status": "processed",
      "is_uncategorized": false,
      "is_expired": false,
      "gl_code": "LG001",
      "exchange_rate": 66.943366,
      "start_reading": "",
      "end_reading": "",
      "payment_mode": "Check",
      "customer_id": "27927000000075081",
      "customer_name": "ACME Corp.",
      "custom_fields": [
        {
          "customfield_id": "16367000000277001",
          "label": "Other Name",
          "value": " Contoso Car Rentrals, Tues 6/19 at 7:00 AM"
        }
      ],
      "project_id": "27927000001243001",
      "project_name": "Coffee Research",
      "transaction_description": "",
      "tax_id": "16367000000086001",
      "tax_name": "Sales Tax",
      "tax_percentage": 2,
      "amount": 207.65,
      "is_inclusive_tax": false,
      "vehicle_type": "Bike",
      "vehicle_id": "17456000000078029",
      "fuel_type": "lpg",
      "engine_capacity_range": "between_1401cc_and_1600cc",
      "is_personal": false,
      "policy_id": "16367000000092011",
      "policy_name": "LIC",
      "documents": [
        {
          "file_name": "receipt1.jpg",
          "file_size_formatted": "71.8 KB",
          "attachment_order": 1,
          "document_id": "16367000000083071"
        }
      ],
      "reimbursement_reference": "",
      "reimbursement_date": "",
      "reimbursement_paid_through_account_id": "",
      "reimbursement_paid_through_account_name": "",
      "reimbursement_currency_id": "",
      "reimbursement_currency_code": ""
    },
    {
      "expense_id": "16367000000083065",
      "date": "2019-06-21",
      "description": "Excess Baggage Cost",
      "created_by": "636967159200000000",
      "created_by_name": "PATRICIA",
      "employee_number": "E001",
      "currency_id": "16367000000000097",
      "currency_code": "USD",
      "paid_through_account_id": "16367000000036003",
      "paid_through_account_name": "Employee Reimbursements",
      "bcy_total": 13900.79,
      "bcy_subtotal": 13900.79,
      "total": 50.38,
      "total_without_tax": 4.3,
      "is_billable": true,
      "is_reimbursable": false,
      "reference_number": "DD145",
      "due_days": "Due in 15 days",
      "merchant_id": "16367000000074027",
      "merchant_name": "ABS Solutions",
      "status": "submitted",
      "created_time": "2019-06-21T18:33:12+0800",
      "last_modified_time": "2017-02-21T18:42:46+0530",
      "receipt_name": "receipt1.jpg",
      "report_id": "16367000000083075",
      "mileage_type": "non_mileage",
      "report_name": "Purchase",
      "is_receipt_only": false,
      "distance": 0,
      "per_diem_rate": 0,
      "per_diem_days": 0,
      "per_diem_id": "",
      "per_diem_name": "",
      "expense_type": "non_mileage",
      "location": "Washington",
      "receipt_type": "jpg",
      "policy_violated": false,
      "comments_count": 0,
      "report_status": "submitted",
      "price_precision": 2,
      "mileage_rate": 0,
      "mileage_unit": "km",
      "receipt_status": "processed",
      "is_uncategorized": false,
      "is_expired": false,
      "gl_code": "LG001",
      "exchange_rate": 66.943366,
      "start_reading": "",
      "end_reading": "",
      "payment_mode": "Check",
      "customer_id": "27927000000075081",
      "customer_name": "ACME Corp.",
      "custom_fields": [],
      "project_id": "27927000001243001",
      "project_name": "Coffee Research",
      "transaction_description": "",
      "tax_id": "16367000000086001",
      "tax_name": "Sales Tax",
      "tax_percentage": 2,
      "amount": 207.65,
      "is_inclusive_tax": false,
      "vehicle_type": "Bike",
      "vehicle_id": "17456000000078029",
      "fuel_type": "lpg",
      "engine_capacity_range": "between_1401cc_and_1600cc",
      "is_personal": false,
      "policy_id": "16367000000092011",
      "policy_name": "LIC",
      "documents": [
        {
          "file_name": "receipt1.jpg",
          "file_size_formatted": "71.8 KB",
          "attachment_order": 1,
          "document_id": "16367000000083071"
        }
      ],
      "reimbursement_reference": "",
      "reimbursement_date": "",
      "reimbursement_paid_through_account_id": "",
      "reimbursement_paid_through_account_name": "",
      "reimbursement_currency_id": "",
      "reimbursement_currency_code": ""
    }
  ]
}
